import React, { type ReactElement, type ReactNode } from 'react';

import GradientBackground from '@components/layout/ColorGlowBackground/components/GradientBackground';

import styles from './ColorGlowBackground.module.scss';

type ColoredBackgroundProps = {
    children: ReactNode;
};

const ColorGlowBackground = ({ children }: ColoredBackgroundProps): ReactElement => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>{children}</div>
            <GradientBackground />
        </div>
    );
};

export default ColorGlowBackground;
